/* eslint-disable */ 
import { URL } from '../../../config'
import { getRequest } from '../../../utils/functions/httpRequest'

export const getUpcomingEvents = function () 
{
    const endpoint = `/upcomingEvents`
    const rankingURL = `${URL.ranking}${endpoint}` 
    return getRequest(rankingURL)
} 


// WEBPACK FOOTER //
// ./src/components/pages/api/getUpcomingEvents.js